import { useEffect, useState } from "react";
import Countdown from "react-countdown"
import { IOrder } from "../../interface/IOrder";
import { useSelector } from "react-redux";

export const CountdownOrderTimer = ({ callBack }: { callBack?: () => void }) => {
    const renderer = ({ formatted }: any) => {
        return <span>{formatted.minutes}:{formatted.seconds}</span>;
    }
    const [dateTime, setDateTime] = useState<string | null>(null)
    const order = useSelector((state: any) => state.order) as IOrder


    useEffect(() => {
        if (order.statusExpiration) {
            if (order.statusExpiration.endsWith('Z')) {
                setDateTime(order.statusExpiration)
                console.log(order.statusExpiration)
            } else {
                setDateTime(order.statusExpiration + 'Z')
                console.log(order.statusExpiration)
            }
        }
    }, [order])


    return (
        <>
            {dateTime &&
                <>
                    <div className="text-center">
                        Оставшееся время для оформления заказа: <b><Countdown
                            date={new Date(order.statusExpiration)}
                            autoStart={true}
                            renderer={renderer}
                            onComplete={() => { callBack && callBack() }}
                            zeroPadTime={2}
                        />
                        </b>
                    </div>
                </>
            }
        </>
    )
}
